if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.hqApplyOffset = this.hqApplyOffset.bind(this);
    }

    /* Haqiqi fix 2026-11-01: keep the page where it was when the popup opens and closes
       (no jump), and keep the layout from shifting when the scrollbar is hidden. */
    hide() {
      const y = typeof this.hqScrollY === 'number' ? this.hqScrollY : window.scrollY;
      document.body.classList.remove('overflow-hidden');
      document.body.style.removeProperty('padding-right');
      this.removeAttribute('open');
      removeTrapFocus();
      if (this.openedBy && this.openedBy.focus) this.openedBy.focus({ preventScroll: true });
      window.pauseAllMedia();
      this.hqResetOffset();
      window.scrollTo(0, y);
      requestAnimationFrame(() => window.scrollTo(0, y));
    }

    show(opener) {
      this.hqScrollY = window.scrollY;
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar > 4) document.body.style.paddingRight = scrollbar + 'px';
      super.show(opener);
      this.showActiveMedia();
      this.hqFitBelowHeader();
      window.scrollTo(0, this.hqScrollY);
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      const container = this.querySelector('[role="document"]');
      container.scrollTop = Math.max(0, activeMedia.offsetTop - container.offsetTop);
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    /* Haqiqi fix 2026-11-01: the popup starts right below the site header, the picture sits
       at the top (no empty band), and the close (X) button sits on the picture's top-right corner. */
    hqHeaderSection() {
      const headerBottom = document.querySelector('.header_bottom');
      return headerBottom ? headerBottom.closest('.shopify-section') : null;
    }

    hqApplyOffset() {
      if (!this.hasAttribute('open')) return;
      const header = this.hqHeaderSection();
      if (!header) return;
      header.classList.remove('header-hidden');
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      this.style.top = bottom + 'px';
      this.style.height = 'calc(100% - ' + bottom + 'px)';
      const dialog = this.querySelector('.product-media-modal__dialog');
      if (dialog) {
        dialog.style.height = '100%';
        dialog.style.alignItems = 'flex-start';
      }
      const content = this.querySelector('.product-media-modal__content');
      if (content) {
        content.style.maxHeight = '100%';
        if (window.innerWidth < 750) content.style.paddingTop = '0px';
      }
      const toggle = this.querySelector('.product-media-modal__toggle');
      if (toggle) {
        const media = this.querySelector('.product-media-modal__content > .active') ||
          this.querySelector('.product-media-modal__content > img, .product-media-modal__content > *');
        const rect = media ? media.getBoundingClientRect() : null;
        const gap = window.innerWidth < 750 ? 10 : 14;
        const top = rect ? Math.max(bottom, Math.round(rect.top)) : bottom;
        toggle.style.top = (top + gap) + 'px';
        if (rect && rect.width > 0) toggle.style.right = Math.max(gap, Math.round(window.innerWidth - rect.right + gap)) + 'px';
        toggle.style.backgroundColor = 'rgba(255, 255, 255, 0.92)';
        toggle.style.color = '#1c1c1c';
        toggle.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.25)';
      }
    }

    hqFitBelowHeader() {
      this.hqApplyOffset();
      requestAnimationFrame(this.hqApplyOffset);
      setTimeout(this.hqApplyOffset, 120);
      setTimeout(this.hqApplyOffset, 400);
      window.addEventListener('scroll', this.hqApplyOffset, { passive: true });
      window.addEventListener('resize', this.hqApplyOffset);
    }

    hqResetOffset() {
      window.removeEventListener('scroll', this.hqApplyOffset);
      window.removeEventListener('resize', this.hqApplyOffset);
      this.style.removeProperty('top');
      this.style.removeProperty('height');
      const dialog = this.querySelector('.product-media-modal__dialog');
      if (dialog) {
        dialog.style.removeProperty('height');
        dialog.style.removeProperty('align-items');
      }
      const content = this.querySelector('.product-media-modal__content');
      if (content) {
        content.style.removeProperty('max-height');
        content.style.removeProperty('padding-top');
      }
      const toggle = this.querySelector('.product-media-modal__toggle');
      if (toggle) {
        ['top', 'right', 'background-color', 'color', 'box-shadow'].forEach((p) => toggle.style.removeProperty(p));
      }
    }
  });
}
